// extracted by mini-css-extract-plugin
export var _3x3 = "field-module--_3x3--89554";
export var _4x4 = "field-module--_4x4--70bd7";
export var alien = "field-module--alien--5c418";
export var cake1 = "field-module--cake1--7c11d";
export var cosmos1 = "field-module--cosmos1--9fa49";
export var cosmos2 = "field-module--cosmos2--e65cf";
export var cosmos3 = "field-module--cosmos3--4bbdd";
export var cosmos4 = "field-module--cosmos4--5648a";
export var cosmos5 = "field-module--cosmos5--ade4d";
export var cosmos6 = "field-module--cosmos6--68ce3";
export var cosmos7 = "field-module--cosmos7--379f9";
export var cosmos8 = "field-module--cosmos8--b6023";
export var error = "field-module--error--9999a";
export var field = "field-module--field--7dc79";
export var find = "field-module--find--c4d95";
export var ghost = "field-module--ghost--bba4e";
export var invisible = "field-module--invisible--cddd1";
export var portalRed = "field-module--portal-red--81515";
export var portalViolet = "field-module--portal-violet--11ba8";
export var right = "field-module--right--e098d";
export var rocket = "field-module--rocket--4df72";
export var success = "field-module--success--42d1b";
export var ufo = "field-module--ufo--d84d8";